import { useCallback } from 'react';
import type { SiteStatus } from 'types/Site';
import { useGet } from 'utils/hooks/useAPI';

export interface SiteState {
    site_id: number;
    name: string;
    status?: SiteStatus;
    company_id?: number;
    company_name?: string;
    company_role?: string;
    site_notes_count?: number;
    company_notes_count?: number;
}

const getSiteStateApi = (siteId?: number) =>
    siteId ? `/helios-api/sites/${siteId}` : '';

export const useSiteState = () => {
    const [, loadSite] = useGet<SiteState>(getSiteStateApi(), true);

    return useCallback(
        async (siteId: number) => {
            try {
                const baseURL = getSiteStateApi(siteId);
                return await loadSite({ baseURL });
            } catch {
                return undefined;
            }
        },
        [loadSite]
    );
};
